import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { taskKeys } from "./query-keys";

export function useExecuteTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.tasks.start,
    onSuccess: async (_data, taskId) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: taskKeys.all }),
        queryClient.invalidateQueries({ queryKey: taskKeys.logs(taskId) }),
      ]);
    },
  });
}

export function useCancelTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.tasks.cancel,
    onSuccess: async (_data, taskId) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: taskKeys.all }),
        queryClient.invalidateQueries({ queryKey: taskKeys.logs(taskId) }),
      ]);
    },
  });
}
